import React, { Fragment, useContext, useEffect, useState } from "react";

/**
 * Components
 */
import Heading from "components/heading/heading";
import BaseButton from "../../components/base-button/base-button";
import { FlexRow } from "../../components/flex-row/flex-row";
import IconInfoGeneral from "../../assets/svg/icon-info-general.svg";
import { MainStore } from "../../stores/Main";

const ModalEmailOptOut = (props) => {
  const { title, accept, reject } = props.modalProps;
  const mainStore = useContext(MainStore);

  return (
    <Fragment>
      <Heading text={title} icon={IconInfoGeneral} />
      <div className="scrollBox" style={{ marginBottom: "10px" }}>
        <p style={{ marginBottom: "5px" }}>
          By opting out of email communications, you are disconnecting your
          access to view and manage your accounts with this agency. If you
          proceed and disconnect, you will lose access to your account
          information through this platform and {mainStore.profile.agency.name}{" "}
          is notified that you do not wish to manage your accounts using the
          Freede platform. {mainStore.profile.agency.name} may choose to contact
          you another way to resolve these accounts.
        </p>
        <p>
          Please be aware that when you disconnect your access to view and
          manage your accounts with {mainStore.profile.agency.name}, Freede will
          cancel any future scheduled payments intended to be remitted to{" "}
          {mainStore.profile.agency.name} through this platform that have not
          already been initiated, however, your commitments to remit payment for
          any payment arrangement negotiated through the Freede platform or with{" "}
          {mainStore.profile.agency.name} or any other party are still in
          effect. Payment remittance instructions can be obtained by contacting{" "}
          {mainStore.profile.agency.name} at{" "}
          {mainStore.profile.agency.phone_toll} during regular business hours (
          {mainStore.profile.agency.hours}).
        </p>
      </div>
      <FlexRow className="justify-content--center">
        <div style={{ textAlign: "center" }}>
          <BaseButton type="button" className="btn--alt" onClick={accept}>
            I have read and accept the above
          </BaseButton>
          <br />
          <br />
          <BaseButton type="button" onClick={reject}>
            I do not accept
          </BaseButton>
        </div>
      </FlexRow>
    </Fragment>
  );
};

export default ModalEmailOptOut;
